// src/components/utils/Validaciones.js

const mostrarError = (toastRef, mensaje) => {  
  const toastFn = toastRef?.current;

  if (!toastFn || typeof toastFn.show !== 'function') {
  console.error('❌ toastRef no es válido:', toastRef?.current, mensaje);
  return;
} else {
  console.log('✅ Mostrando toast con mensaje:', mensaje);
}
  toastFn.show({
    severity: 'error',
    summary: 'Error',
    detail: mensaje,
    life: 5000
  });
};

const Validaciones = {
  validarCamposRequeridos(product, toastRef, enviar) {
     if (product.codigo === '') {
      mostrarError(toastRef, 'Debe seleccionar el formulario, verifique por favor...');
      return false;
    }
    if (product.nid_propietario === '') {
      mostrarError(toastRef, 'Debe seleccionar el Propietario, verifique por favor...');
      return false;
    }
    if (enviar && product.numero=='') {
      mostrarError(toastRef, 'Debe digitar el número, verifique por favor...');
      return false;
    }
    if (product.estado === '') {
      mostrarError(toastRef, 'Debe seleccionar el estado, verifique por favor...');
      return false;
    }

    return true;
  }
};

export default Validaciones;
